const description =
  "Outsmart the Sportsbook everyday. Proven computer model betting predictions make sports betting easy. Get the best bets today with real-time betting line movement and expert tips.";

export default {
  description,
  facebook: {
    appId: "159390208060520",
  },
  openGraph: {
    type: "website",
    description,
    title: "BetQL",
    locale: "en_US",
    site_name: "BetQL",
    image: {
      url: "https://betql.co/ogimage.jpg",
      width: 1200,
      height: 630,
      alt: "BetQL",
    },
  },
  twitter: {
    handle: "@betqlapp",
    site: "@betqlapp",
    creator: "@betqlapp",
    cardType: "summary_large_image",
  },
};
